import $ from 'jquery';
import { updateComments as dynamicCsrfUpdateComments } from '@ui/comments/dynamic-csrf';

const elements = {
    config: '.c-comments-config',
    homeConfig: '.c-comments__home__config',
};

export class loadCommentsAsync {
    constructor() {
        this.mapCriterion = {};
        $(window).ready(() => {
            this.mapCriterion = {
                date: $(elements.config).attr('data-comments-api-latest'),
                rating: $(elements.config).attr('data-comments-api-best'),
                recommended: $(elements.config).attr('data-comments-api-recommended'),
            };
            this.loadRawUrl = $(elements.homeConfig).attr(
                'data-comments-api-main-page',
            );
        });
    }
    load(criterion = 'date') {
        const url = this.mapCriterion[criterion];
        const promise = new Promise((resolve, reject) => {
            $.get(url)
                .done(response => {
                    const { status, data, redirectURL } = response;
                    switch (status) {
                        case 'ok':
                            dynamicCsrfUpdateComments(data.csrfToken);
                            resolve(data);
                            break;
                        case 'error':
                            reject(data.error);
                            break;
                        case 'redirect':
                            window.location.href = redirectURL;
                            break;
                        default:
                            break;
                    }
                })
                .fail(error => {
                    reject(error);
                });
        });

        return promise;
    }
    loadRaw(id) {
        const url = id
            ? `${this.loadRawUrl}?last_comment_id=${id}`
            : this.loadRawUrl;
        const promise = new Promise((resolve, reject) => {
            $.get(url).done(response => {
                const { status, data, redirectURL } = response;

                if (status === "ok") {
                    resolve(data);
                } else if (status === "error") {
                    reject(data.error);
                } else if (status === "redirect") {
                    window.location.href = redirectURL;
                }
            });
        });

        return promise;
    }
}

export const repository = new loadCommentsAsync();



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/repositories/loadCommentsAsync.js